
export const nationalities = [
    { id: 1, name: 'WNI' },
    { id: 2, name: 'WNA' },
]

export const genders = [
    { id: 1, name: 'Pria' },
    { id: 2, name: 'Wanita' }
]

export const nPWPs = [
    { id: '2', name: 'YA' },
    { id: '1', name: 'Tidak Ada' },
   
]

export const maritalStatuses = [
    { id: 1, name: 'Belum Menikah' },
    { id: 2, name: 'Menikah' },
    { id: 3, name: 'Duda' },
    { id: 4, name: 'Janda' }
]

export const religions = [
    { id: 1, name: 'Islam' },
    { id: 2, name: 'Katolik' },
    { id: 3, name: 'Kristen' },
    { id: 4, name: 'Hindu' },
    { id: 5, name: 'Budha' },
    { id: 6, name: 'Aliran Kepercayaan' },
    { id: 7, name: 'Khonghucu' }
]

export const educations = [
    { id: 2, name: 'Sekolah Dasar' },
    { id: 3, name: 'Sekolah Menengah Pertama' },
    { id: 4, name: 'Sekolah Menengah Atas' },
    { id: 5, name: 'Diploma (D3)' },
    { id: 6, name: 'Sarjana (S1)' },
    { id: 7, name: 'Magister (S2)' },
    { id: 8, name: 'Doktor (S3)' },
    { id: 1, name: 'Lainnya' }
]

export const occupationBOs = [
    { id: 1, name: 'Others (Lainnya)' },
    { id: 2, name: 'Private Employee (Karyawan Swasta)' },
    { id: 3, name: 'Civil Servant (Pegawai Negri)' },
    { id: 4, name: 'Housewife (Ibu Rumah Tangga)' },
    { id: 5, name: 'Entrepreneur (Pengusaha)' },
    { id: 6, name: 'Student (Pelajar)' },
    { id: 7, name: 'TNI/Police (TNI/Polisi)' },
    { id: 8, name: 'Retirement (Pensiunan)' },
    { id: 9, name: 'investorOccupation' }
]

export const incomePerAnnums = [
    { id: 1, name: '< Rp. 10 Juta' },
    { id: 2, name: 'Rp. 10 Juta - Rp. 50 Juta' },
    { id: 3, name: 'Rp. 50 Juta - Rp. 100 Juta' },
    { id: 4, name: 'Rp. 100 Juta - Rp. 500 Juta' },
    { id: 5, name: 'Rp. 500 Juta - Rp. 1 Milyar' },
    { id: 6, name: ' > Rp. 1 Milyar' }
]

export const incomePerMonths = [
    { id: 1, name: 's/d 5 Juta' },
    { id: 2, name: '> 5 Juta ≤ 10 Juta' },
    { id: 3, name: '> 10 Juta ≤ 25 Juta' },
    { id: 4, name: '> 25 Juta ≤ 50 Juta' },
    { id: 5, name: '> 50 Juta ≤ 100 Juta' },
    { id: 6, name: '> 100 Juta' }
]

export const dailyNormalTransactions = [
    { id: 1, name: 's/d 10 Juta' },
    { id: 2, name: '> 10 Juta ≤ 50 Juta' },
    { id: 3, name: '> 50 Juta ≤ 100 Juta' },
    { id: 4, name: '> 100 Juta ≤ 1 Milyar' },
    { id: 5, name: '> 1 Milyar' }
]

export const incomePerAnnumBCAs = [
    { id: 1, name: 'Rp. 0 - Rp. 50 Juta' },
    { id: 2, name: '>Rp. 50 Juta - Rp. 250 Juta' },
    { id: 3, name: '>Rp. 250 Juta - Rp. 500 Juta' },
    { id: 4, name: '>Rp. 500 Juta - Rp. 1,5 M' },
    { id: 5, name: '>Rp. 1,5 M' }
]

export const expensesPerMonths = [
    { id: 1, name: 'Rp. 0 - Rp. 5 Juta' },
    { id: 2, name: '>Rp. 5 Juta - Rp. 10 Juta' },
    { id: 3, name: '>Rp. 10 Juta - Rp. 25 Juta' },
    { id: 4, name: '>Rp. 25 Juta - Rp. 50 M' },
    { id: 5, name: '>Rp. 50 Juta - Rp. 100 Juta' },
    { id: 6, name: '>Rp. 100 Juta' }
]

export const fundSources = [
    { id: 2, name: 'Gaji' },
    { id: 3, name: 'Hasil Usaha' },
    { id: 4, name: 'Bunga' },
    { id: 5, name: 'Warisan' },
    { id: 6, name: 'Pemberian Orang Tua/Anak' },
    { id: 7, name: 'Pemberian Dari Pasangan' },
    { id: 8, name: 'Dana Pensiunan' },
    { id: 9, name: 'Undian' },
    { id: 10, name: 'Hasil Investasi' },
    { id: 11, name: 'Deposito' },
    { id: 12, name: 'Kapital' },
    { id: 13, name: 'Pinjaman' },
    { id: 1, name: 'Lainnya' }
]

export const incomeSources = [
    { id: 2, name: 'Hasil Usaha' },
    { id: 3, name: 'Hasil Investasi' },
    { id: 4, name: 'Orang Tua' },
    { id: 5, name: 'Gaji' },
    { id: 6, name: 'Bonus' },
    { id: 7, name: 'Suami/Istri' },
    { id: 8, name: 'Tunjangan' },
    { id: 9, name: 'Uang Sewa' },
    { id: 10, name: 'Pinjaman' },
    { id: 11, name: 'Hibah' },
    { id: 12, name: 'Deposito' },
    { id: 1, name: 'Lainnya' },
]

export const incomeSourcesBeneficialOwner = [
    { id: 2, name: 'Hasil Usaha' },
    { id: 3, name: 'Hasil Investasi' },
    { id: 5, name: 'Gaji' },
]

export const investmentObjectives = [
    { id: 2, name: 'Apresiasi Harga' },
    { id: 3, name: 'Investasi Jangka Panjang' },
    { id: 4, name: 'Spekulasi' },
    { id: 5, name: 'Sumber Pendapatan' },
    { id: 1, name: 'Lainnya' }
]

export const fATCAs = [
    { id: 1, name: 'YA' },
    { id: 2, name: 'TIDAK' }
]

export const yesOrNo = [
    { id: 1, name: 'YA' },
    { id: 2, name: 'TIDAK' }
]


export const assetOwnerships = [
    { id: 1, name: 'Diri Sendiri' },
    // { id: 2, name: 'Merepresentasikan Pihak Lain' }
]

export const countries = [
    { id: 'AF', name: 'AFGHANISTAN' },
    { id: 'AX', name: 'ÅLAND ISLANDS' },
    { id: 'AL', name: 'ALBANIA' },
    { id: 'DZ', name: 'ALGERIA' },
    { id: 'AS', name: 'AMERICAN SAMOA' },
    { id: 'AD', name: 'ANDORRA' },
    { id: 'AO', name: 'ANGOLA' },
    { id: 'AI', name: 'ANGUILLA' },
    { id: 'AQ', name: 'ANTARCTICA' },
    { id: 'AG', name: 'ANTIGUA AND BARBUDA' },
    { id: 'AR', name: 'ARGENTINA' },
    { id: 'AM', name: 'ARMENIA' },
    { id: 'AW', name: 'ARUBA' },
    { id: 'AU', name: 'AUSTRALIA' },
    { id: 'AT', name: 'AUSTRIA' },
    { id: 'AZ', name: 'AZERBAIJAN' },
    { id: 'BS', name: 'BAHAMAS' },
    { id: 'BH', name: 'BAHRAIN' },
    { id: 'BD', name: 'BANGLADESH' },
    { id: 'BB', name: 'BARBADOS' },
    { id: 'BY', name: 'BELARUS' },
    { id: 'BE', name: 'BELGIUM' },
    { id: 'BZ', name: 'BELIZE' },
    { id: 'BJ', name: 'BENIN' },
    { id: 'BM', name: 'BERMUDA' },
    { id: 'BT', name: 'BHUTAN' },
    { id: 'BO', name: 'BOLIVIA, PLURINATIONAL STATE OF' },
    { id: 'BQ', name: 'BONAIRE, SINT EUSTATIUS AND SABA' },
    { id: 'BA', name: 'BOSNIA AND HERZEGOVINA' },
    { id: 'BW', name: 'BOTSWANA' },
    { id: 'BV', name: 'BOUVET ISLAND' },
    { id: 'BR', name: 'BRAZIL' },
    { id: 'IO', name: 'BRITISH INDIAN OCEAN TERRITORY' },
    { id: 'BN', name: 'BRUNEI DARUSSALAM' },
    { id: 'BG', name: 'BULGARIA' },
    { id: 'BF', name: 'BURKINA FASO' },
    { id: 'BI', name: 'BURUNDI' },
    { id: 'KH', name: 'CAMBODIA' },
    { id: 'CM', name: 'CAMEROON' },
    { id: 'CA', name: 'CANADA' },
    { id: 'CV', name: 'CAPE VERDE' },
    { id: 'KY', name: 'CAYMAN ISLANDS' },
    { id: 'CF', name: 'CENTRAL AFRICAN REPUBLIC' },
    { id: 'TD', name: 'CHAD' },
    { id: 'CL', name: 'CHILE' },
    { id: 'CN', name: 'CHINA' },
    { id: 'CX', name: 'CHRISTMAS ISLAND' },
    { id: 'CC', name: 'COCOS (KEELING) ISLANDS' },
    { id: 'CO', name: 'COLOMBIA' },
    { id: 'KM', name: 'COMOROS' },
    { id: 'CG', name: 'CONGO' },
    { id: 'CD', name: 'CONGO, THE DEMOCRATIC REPUBLIC OF THE' },
    { id: 'CK', name: 'COOK ISLANDS' },
    { id: 'CR', name: 'COSTA RICA' },
    { id: 'CI', name: 'CÔTE DIVOIRE' },
    { id: 'HR', name: 'CROATIA' },
    { id: 'CU', name: 'CUBA' },
    { id: 'CW', name: 'CURAÇAO' },
    { id: 'CY', name: 'CYPRUS' },
    { id: 'CZ', name: 'CZECH REPUBLIC' },
    { id: 'DK', name: 'DENMARK' },
    { id: 'DJ', name: 'DJIBOUTI' },
    { id: 'DM', name: 'DOMINICA' },
    { id: 'DO', name: 'DOMINICAN REPUBLIC' },
    { id: 'EC', name: 'ECUADOR' },
    { id: 'EG', name: 'EGYPT' },
    { id: 'SV', name: 'EL SALVADOR' },
    { id: 'GQ', name: 'EQUATORIAL GUINEA' },
    { id: 'ER', name: 'ERITREA' },
    { id: 'EE', name: 'ESTONIA' },
    { id: 'ET', name: 'ETHIOPIA' },
    { id: 'FK', name: 'FALKLAND ISLANDS (MALVINAS)' },
    { id: 'FO', name: 'FAROE ISLANDS' },
    { id: 'FJ', name: 'FIJI' },
    { id: 'FI', name: 'FINLAND' },
    { id: 'FR', name: 'FRANCE' },
    { id: 'GF', name: 'FRENCH GUIANA' },
    { id: 'PF', name: 'FRENCH POLYNESIA' },
    { id: 'TF', name: 'FRENCH SOUTHERN TERRITORIES' },
    { id: 'GA', name: 'GABON' },
    { id: 'GM', name: 'GAMBIA' },
    { id: 'GE', name: 'GEORGIA' },
    { id: 'DE', name: 'GERMANY' },
    { id: 'GH', name: 'GHANA' },
    { id: 'GI', name: 'GIBRALTAR' },
    { id: 'GR', name: 'GREECE' },
    { id: 'GL', name: 'GREENLAND' },
    { id: 'GD', name: 'GRENADA' },
    { id: 'GP', name: 'GUADELOUPE' },
    { id: 'GU', name: 'GUAM' },
    { id: 'GT', name: 'GUATEMALA' },
    { id: 'GG', name: 'GUERNSEY' },
    { id: 'GN', name: 'GUINEA' },
    { id: 'GW', name: 'GUINEA-BISSAU' },
    { id: 'GY', name: 'GUYANA' },
    { id: 'HT', name: 'HAITI' },
    { id: 'HM', name: 'HEARD ISLAND AND MCDONALD ISLANDS' },
    { id: 'VA', name: 'HOLY SEE (VATICAN CITY STATE)' },
    { id: 'HN', name: 'HONDURAS' },
    { id: 'HK', name: 'HONG KONG' },
    { id: 'HU', name: 'HUNGARY' },
    { id: 'IS', name: 'ICELAND' },
    { id: 'IN', name: 'INDIA' },
    { id: 'ID', name: 'INDONESIA' },
    { id: 'IR', name: 'IRAN, ISLAMIC REPUBLIC OF' },
    { id: 'IQ', name: 'IRAQ' },
    { id: 'IE', name: 'IRELAND' },
    { id: 'IM', name: 'ISLE OF MAN' },
    { id: 'IL', name: 'ISRAEL' },
    { id: 'IT', name: 'ITALY' },
    { id: 'JM', name: 'JAMAICA' },
    { id: 'JP', name: 'JAPAN' },
    { id: 'JE', name: 'JERSEY' },
    { id: 'JO', name: 'JORDAN' },
    { id: 'KZ', name: 'KAZAKHSTAN' },
    { id: 'KE', name: 'KENYA' },
    { id: 'KI', name: 'KIRIBATI' },
    { id: 'KP', name: 'KOREA, DEMOCRATIC PEOPLES REPUBLIC OF' },
    { id: 'KR', name: 'KOREA, REPUBLIC OF' },
    { id: 'KW', name: 'KUWAIT' },
    { id: 'KG', name: 'KYRGYZSTAN' },
    { id: 'LA', name: 'LAO PEOPLES DEMOCRATIC REPUBLIC' },
    { id: 'LV', name: 'LATVIA' },
    { id: 'LB', name: 'LEBANON' },
    { id: 'LS', name: 'LESOTHO' },
    { id: 'LR', name: 'LIBERIA' },
    { id: 'LY', name: 'LIBYA' },
    { id: 'LI', name: 'LIECHTENSTEIN' },
    { id: 'LT', name: 'LITHUANIA' },
    { id: 'LU', name: 'LUXEMBOURG' },
    { id: 'MO', name: 'MACAO' },
    { id: 'MK', name: 'MACEDONIA, THE FORMER YUGOSLAV REPUBLIC OF' },
    { id: 'MG', name: 'MADAGASCAR' },
    { id: 'MW', name: 'MALAWI' },
    { id: 'MY', name: 'MALAYSIA' },
    { id: 'MV', name: 'MALDIVES' },
    { id: 'ML', name: 'MALI' },
    { id: 'MT', name: 'MALTA' },
    { id: 'MH', name: 'MARSHALL ISLANDS' },
    { id: 'MQ', name: 'MARTINIQUE' },
    { id: 'MR', name: 'MAURITANIA' },
    { id: 'MU', name: 'MAURITIUS' },
    { id: 'YT', name: 'MAYOTTE' },
    { id: 'MX', name: 'MEXICO' },
    { id: 'FM', name: 'MICRONESIA, FEDERATED STATES OF' },
    { id: 'MD', name: 'MOLDOVA, REPUBLIC OF' },
    { id: 'MC', name: 'MONACO' },
    { id: 'MN', name: 'MONGOLIA' },
    { id: 'ME', name: 'MONTENEGRO' },
    { id: 'MS', name: 'MONTSERRAT' },
    { id: 'MA', name: 'MOROCCO' },
    { id: 'MZ', name: 'MOZAMBIQUE' },
    { id: 'MM', name: 'MYANMAR' },
    { id: 'NA', name: 'NAMIBIA' },
    { id: 'NR', name: 'NAURU' },
    { id: 'NP', name: 'NEPAL' },
    { id: 'NL', name: 'NETHERLANDS' },
    { id: 'NC', name: 'NEW CALEDONIA' },
    { id: 'NZ', name: 'NEW ZEALAND' },
    { id: 'NI', name: 'NICARAGUA' },
    { id: 'NE', name: 'NIGER' },
    { id: 'NG', name: 'NIGERIA' },
    { id: 'NU', name: 'NIUE' },
    { id: 'NF', name: 'NORFOLK ISLAND' },
    { id: 'MP', name: 'NORTHERN MARIANA ISLANDS' },
    { id: 'NO', name: 'NORWAY' },
    { id: 'OM', name: 'OMAN' },
    { id: 'PK', name: 'PAKISTAN' },
    { id: 'PW', name: 'PALAU' },
    { id: 'PS', name: 'PALESTINE, STATE OF' },
    { id: 'PA', name: 'PANAMA' },
    { id: 'PG', name: 'PAPUA NEW GUINEA' },
    { id: 'PY', name: 'PARAGUAY' },
    { id: 'PE', name: 'PERU' },
    { id: 'PH', name: 'PHILIPPINES' },
    { id: 'PN', name: 'PITCAIRN' },
    { id: 'PL', name: 'POLAND' },
    { id: 'PT', name: 'PORTUGAL' },
    { id: 'PR', name: 'PUERTO RICO' },
    { id: 'QA', name: 'QATAR' },
    { id: 'RE', name: 'RÉUNION' },
    { id: 'RO', name: 'ROMANIA' },
    { id: 'RU', name: 'RUSSIAN FEDERATION' },
    { id: 'RW', name: 'RWANDA' },
    { id: 'BL', name: 'SAINT BARTHÉLEMY' },
    { id: 'SH', name: 'SAINT HELENA, ASCENSION AND TRISTAN DA CUNHA' },
    { id: 'KN', name: 'SAINT KITTS AND NEVIS' },
    { id: 'LC', name: 'SAINT LUCIA' },
    { id: 'MF', name: 'SAINT MARTIN (FRENCH PART)' },
    { id: 'PM', name: 'SAINT PIERRE AND MIQUELON' },
    { id: 'VC', name: 'SAINT VINCENT AND THE GRENADINES' },
    { id: 'WS', name: 'SAMOA' },
    { id: 'SM', name: 'SAN MARINO' },
    { id: 'ST', name: 'SAO TOME AND PRINCIPE' },
    { id: 'SA', name: 'SAUDI ARABIA' },
    { id: 'SN', name: 'SENEGAL' },
    { id: 'RS', name: 'SERBIA' },
    { id: 'SC', name: 'SEYCHELLES' },
    { id: 'SL', name: 'SIERRA LEONE' },
    { id: 'SG', name: 'SINGAPORE' },
    { id: 'SX', name: 'SINT MAARTEN (DUTCH PART)' },
    { id: 'SK', name: 'SLOVAKIA' },
    { id: 'SI', name: 'SLOVENIA' },
    { id: 'SB', name: 'SOLOMON ISLANDS' },
    { id: 'SO', name: 'SOMALIA' },
    { id: 'ZA', name: 'SOUTH AFRICA' },
    { id: 'GS', name: 'SOUTH GEORGIA AND THE SOUTH SANDWICH ISLANDS' },
    { id: 'SS', name: 'SOUTH SUDAN' },
    { id: 'ES', name: 'SPAIN' },
    { id: 'LK', name: 'SRI LANKA' },
    { id: 'SD', name: 'SUDAN' },
    { id: 'SR', name: 'SURINAME' },
    { id: 'SJ', name: 'SVALBARD AND JAN MAYEN' },
    { id: 'SZ', name: 'SWAZILAND' },
    { id: 'SE', name: 'SWEDEN' },
    { id: 'CH', name: 'SWITZERLAND' },
    { id: 'SY', name: 'SYRIAN ARAB REPUBLIC' },
    { id: 'TW', name: 'TAIWAN, PROVINCE OF CHINA' },
    { id: 'TJ', name: 'TAJIKISTAN' },
    { id: 'TZ', name: 'TANZANIA, UNITED REPUBLIC OF' },
    { id: 'TH', name: 'THAILAND' },
    { id: 'TL', name: 'TIMOR-LESTE' },
    { id: 'TG', name: 'TOGO' },
    { id: 'TK', name: 'TOKELAU' },
    { id: 'TO', name: 'TONGA' },
    { id: 'TT', name: 'TRINIDAD AND TOBAGO' },
    { id: 'TN', name: 'TUNISIA' },
    { id: 'TR', name: 'TURKEY' },
    { id: 'TM', name: 'TURKMENISTAN' },
    { id: 'TC', name: 'TURKS AND CAICOS ISLANDS' },
    { id: 'TV', name: 'TUVALU' },
    { id: 'UG', name: 'UGANDA' },
    { id: 'UA', name: 'UKRAINE' },
    { id: 'AE', name: 'UNITED ARAB EMIRATES' },
    { id: 'GB', name: 'UNITED KINGDOM' },
    { id: 'US', name: 'UNITED STATES' },
    { id: 'UM', name: 'UNITED STATES MINOR OUTLYING ISLANDS' },
    { id: 'UY', name: 'URUGUAY' },
    { id: 'UZ', name: 'UZBEKISTAN' },
    { id: 'VU', name: 'VANUATU' },
    { id: 'VE', name: 'VENEZUELA, BOLIVARIAN REPUBLIC OF' },
    { id: 'VN', name: 'VIET NAM' },
    { id: 'VG', name: 'VIRGIN ISLANDS, BRITISH' },
    { id: 'VI', name: 'VIRGIN ISLANDS, U.S.' },
    { id: 'WF', name: 'WALLIS AND FUTUNA' },
    { id: 'EH', name: 'WESTERN SAHARA' },
    { id: 'YE', name: 'YEMEN' },
    { id: 'ZM', name: 'ZAMBIA' },
    { id: 'ZW', name: 'ZIMBABWE' }
]



// WEBPACK FOOTER //
// ./src/shared/DataSeed.js